import React from 'react';
import useStore from '@data/state/zustand';
import { DocumentProps } from './DocumentFooter';

const DocumentHeader = (props: DocumentProps) => {
    const { setHeaderHeight, children } = props;
    const imgRef = React.useRef<HTMLImageElement>(null);

    const otherSettings = useStore((appState: any) => appState.otherSettings);

    const getImageUrlFromDocumentHeaderInfo = React.useCallback(() => {
        const documentHeaderInfo = otherSettings?.documentHeader || '';
        const regex = /<img\s+[^>]*src="([^"]*)"/;
        const match = documentHeaderInfo.match(regex);
        return match ? match[1] : '';
    }, [otherSettings]);

    const imageUrl = getImageUrlFromDocumentHeaderInfo();

    React.useEffect(() => {
        if (imageUrl === '') {
            if (setHeaderHeight) {
                setHeaderHeight(100);
            }
        } else {
            const loadImage = new Image();
            loadImage.src = imageUrl;
            loadImage.onload = () => {
                const coefficient = loadImage.width / 900;
                const height = loadImage.height / coefficient;
                console.log('📐 Header image loaded:', {
                    originalWidth: loadImage.width,
                    originalHeight: loadImage.height,
                    coefficient,
                    calculatedHeight: height
                });
                if (setHeaderHeight) {
                    setHeaderHeight(height);
                }
            };
            loadImage.onerror = () => {
                console.error('❌ Header image failed to load:', imageUrl);
                if (setHeaderHeight) {
                    setHeaderHeight(100);
                }
            };
        }
    }, [setHeaderHeight, imageUrl]);

    // Ako nema slike, renderiraš prazan header
    if (!imageUrl) {
        return (
            <div className="text-center" style={{ marginTop: '12px' }}>
                {children}
            </div>
        );
    }

    // DIREKTNO RENDERIRANJE SLIKE - bez <small> wrappera, sa FIKSNOM ŠIRINOM
    return (
        <div className="text-center">
            <img 
                ref={imgRef}
                src={imageUrl} 
                alt="Header"
                style={{ 
                    width: '900px',  // FIKSNA ŠIRINA umjesto 100%
                    maxWidth: '100%',
                    height: 'auto',
                    display: 'block',
                    margin: '0 auto'
                }}
            />
            {children}
        </div>
    );
};

export default DocumentHeader;